export const FIRST_ACTIONABLE_NOISE = 'FIRST_ACTIONABLE_NOISE'
export const SECOND_ACTIONABLE_NOISE = 'SECOND_ACTIONABLE_NOISE'
export const THIRD_ACTIONABLE_NOISE = 'THIRD_ACTIONABLE_NOISE'
export const FIRST_AUTO_RESOLVE_GUEST = 'FIRST_AUTO_RESOLVE_GUEST'
export const SECOND_AUTO_RESOLVE_GUEST = 'SECOND_AUTO_RESOLVE_GUEST'
export const THIRD_AUTO_RESOLVE_PM = 'THIRD_AUTO_RESOLVE_PM'
